import {
  ConfigProvider,
  Flex,
  Typography,
} from 'antd'
import React from 'react'

import {
  formatPercentage,
  formatPrice,
} from '@/utils/formatter'

const { Text } = Typography

export interface EarningGrowth {
  dateStr: string
  earnings: number
  growth?: number,
  channels?: {
    name: string
    earnings: number
  }[]
}

export default function EarningGrowthTooltip({
  dateStr,
  earnings,
  growth,
  channels,
}: EarningGrowth) {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorText: 'var(--ant-color-text)',
        },
      }}
    >
      <Flex vertical>
        <Text strong>{dateStr}</Text>
        <Text>Earnings: {formatPrice()(earnings)}</Text>
        <Text>Growth: {formatPercentage()(growth)}</Text>
        {channels
          ?.filter(c => c.earnings !== 0)
          .map(({ name, earnings: e }) => (
            <Text key={name} style={{ marginLeft: 8, fontSize: 12 }}>{name}: {formatPrice()(e)}</Text>
          ))}
      </Flex>
    </ConfigProvider>
  )
}
